module.exports = __webpack_public_path__ + "img/DGTX.fddeaa9d.svg";